module.exports = __webpack_public_path__ + "static/scale-model-of-oceans-of-fun-in-milwaukee-wisconsin-247c3a9a5db64d3e4e4bdef758b96954.png";